<template>
<div v-if="visible" style="padding: 0px 20px 20px 20px;">

    <!-- <div  class="raised white-background"  style="padding: 20px 20px 20px 20px" > -->
        <img src="static/images/amigo.png" width="80" height="80" alt="" style="float:left;margin-right:14px;" /> 
        <div class="heading">Hey Amigo</div>
        <div class="pa-2">
            I thought I was blind!<br/>You have <b>{{oldTasks.length}}</b> tasks here that are more than 30 days expired. Want me to kill them?
        </div>
        <div class="pa-2 red--text">
            {{clients}}
        </div>
        <v-btn class="tw-action" @click="moreTime = true">give me more time</v-btn>
        <v-btn class="tw-action error" @click="killOldTasks">take them out</v-btn>
    </div>
<!-- </div> -->
</template>

<script>

import DataHelpers from '../helpers/DataHelpers'
import InterfaceField from '../builder/InterfaceField'
import StringHelpers from '../helpers/StringHelpers'
import {subDays} from 'date-fns'
import DateHelpers from '../helpers/DateHelpers';


export default {
    
    data() {
        return {
            moreTime: false,
        }
    },

    components: {
        InterfaceField,
    },
    
    props: {
        tasks: Array,
    },

    computed: {
        oldTasks() {
            const thirtyDaysAgo = DateHelpers.dateToBackwards( subDays(new Date(), 30) )
            // debugger
            return this.tasks.filter(o => o.due < thirtyDaysAgo)
        },
        visible() {
            return !this.moreTime && this.oldTasks.length > 2
        },
        clients() {
            return StringHelpers.sentenceJoin(this.oldTasks.map(o => o.clients))
        },

    },

    methods: {
        async killOldTasks() {
            if(await this.$root.$confirm('Delete', 'Are you sure you want to delete tasks older than 30 days?', { color: 'red' }) == true) {
                this.oldTasks.forEach(task => {
                    let ref = DataHelpers.getRootRef().child(task.meta.path).child(task.meta.key)
                    ref.remove()
                })
            }

        }

    },

    created() {

    }
}
</script>

<style scoped>
.tw-action {
    width:180px;
}
@media (max-width: 380px) {
.tw-action {
    width:100%;
}  
  
}
   
</style>




// WEBPACK FOOTER //
// TaskWarnings.vue?fab78bf8